import styled from 'styled-components';
import chroma from 'chroma-js';

const Swatch = styled.div`
  padding: 3px;
  background: #fff;
  border-radius: 1px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : '')};
`;

const PopOver = styled.div`
  position: absolute;
  right: ${props => (props.isTable ? '45px' : '')};
  z-index: 4;
`;

const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const Color = styled.div`
  width: 36px;
  height: 14px;
  border-radius: 2px;
  background: ${props =>
    chroma(props.color)
      .alpha(props.alpha)
      .css()};
`;

const ChromaContainer = styled.div`
  position: absolute;
  right: -40px;
`;

export default {
  Swatch,
  PopOver,
  Cover,
  Color,
  ChromaContainer
};
